<template>
  <input
    v-if="fieldDefinition.type === 'string'"
    class="input"
    type="text"
    v-model.trim="text"
    :class="classes"
    placeholder="String"
    :disabled="fieldData.loading || !fieldDefinition.editable || undefined"
  />
  <textarea
    v-else-if="fieldDefinition.type === 'text'"
    class="textarea"
    v-model.trim="text"
    :class="classes"
    placeholder="Text"
    :disabled="fieldData.loading || !fieldDefinition.editable || undefined"
  ></textarea>
  <p
    class="help is-danger"
    v-for="(error, i) in [...localErrors, ...fieldData.errors]"
    :key="i"
  >
    {{ error }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { type FieldModel, type FieldProps, defineValidator } from '.'

type Constraint = { type: 'string' | 'text'; many: false }
const { fieldDefinition } = defineProps<FieldProps<Constraint>>()
const fieldData = defineModel<FieldModel<Constraint>>({ required: true })

const classes = computed(() => ({
  'is-danger': !fieldData.value.valid,
  'is-loading': fieldData.value.loading,
}))

const { localErrors } = defineValidator(fieldDefinition, fieldData.value)

const text = computed<string>({
  get() {
    return fieldData.value.value ?? ''
  },
  set(value: string) {
    // Convert an empty string to `null`, because we do not want to have two ways for a text field to be empty, and the backend only allows `null`
    fieldData.value.value = value || null
  },
})

// When mounting the component, check immediately that we do not have an empty string as a value.
// This happens most when the default is set to an empty string.
if (fieldData.value.value?.trim() === '') {
  fieldData.value.value = null
}
</script>
